import { MsalAuthenticationTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { apiConfig, loginRequest } from "../../authConfig";
/*import toast, { Toaster } from 'react-hot-toast';*/

import { Loading } from "../../components/Loading";
import { ErrorComponent } from "../../components/ErrorComponent";
import { GlobalContext } from "../../utils/GlobalContext";
import { SetStateAction, useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { faSortUp, faSortDown, faSort } from '@fortawesome/free-solid-svg-icons';
import { Center, AuthActionLookup, AuthDenialReasonLookup, Client, AuthorizationStatus, PayorInfoType, VwCenterAuthorization, ChoiceOption, VwNoAuthorizations, AuthFeedbackLookup } from "../../utils/Definitions";
import Select, { SingleValue } from "react-select";
import ProtectedPage from "../../utils/ProtectedPage";
import { AuthorizationModal } from "../../components/authorizations/AuthorizationModal";


const InsuranceAuthorizationsContent = () => {

    const globalContext = useContext(GlobalContext);
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(true); // default to load screen

    const [selectedClient, setSelectedClient] = useState<Client | null>(null);
    const [selectedClientId, setSelectedClientId] = useState<number | null>(null);
    const [selectedAuthId, setSelectedAuthId] = useState<string | null>(null);
    const [selectedAuthPayorType, setSelectedAuthPayorType] = useState<string | null>(null);
    const [isAuthorizationModalActive, setIsAuthorizationModalActive] = useState<boolean>(false);
    const [selectedCenter, setSelectedCenter] = useState<Center | null>();

    const [selectedClientChoice, setSelectedClientChoice] = useState<ChoiceOption | null>(null);
    const [clients, setClients] = useState<ChoiceOption[]>([]);
    const [payorInfoTypes, setPayorInfoTypes] = useState<PayorInfoType[]>([]);
    const [authorizationStatuses, setAuthorizationStatuses] = useState<AuthorizationStatus[]>([]);
    const [centerAuthorization, setCenterAuthorization] = useState<VwCenterAuthorization[]>([]);
    const [expiredAuthorizations, setExpiredAuthorizations] = useState<VwCenterAuthorization[]>([]);
    const [authDenialReasons, setAuthDenialReasons] = useState<AuthDenialReasonLookup[]>([]);
    const [authFeedbackOptions, setAuthFeedbackOptions] = useState<AuthFeedbackLookup[]>([]);
    const [authActions, setAuthActions] = useState<AuthActionLookup[]>([]);

    // no auths imported master list
    const [noAuthsImportedMaster, setNoAuthsImportedMaster] = useState<VwNoAuthorizations[]>([]);
    const [noAuthorizationsImportedFiltered, setNoAuthorizationsImportedFiltered] = useState<VwNoAuthorizations[]>([]);

    function NavigateBack() {
        navigate(-1);
    }

    // navigate to the learner edit in admin
    // we cannot send with the chosen client yet. Needs more engineering for this.
    function NavigateToLearnerPage() {
        // TEMP: Learner Administration (learner data management) app disabled — navigation removed
        // navigate("/credentials/learneredit");
    }

    const OnModalClose = () => {
        setSelectedClientId(null);
        setSelectedAuthId(null);
        setSelectedAuthPayorType(null);
        setSelectedClientChoice(null);
        setIsAuthorizationModalActive(false);
    }

    const HandleAuthorizationClick = (authId: string, authPayorType: string, clientId: number) => {
        setSelectedAuthId(authId);
        setSelectedAuthPayorType(authPayorType);
        setSelectedClientId(clientId);
    }

    useEffect(() => {
        if (selectedClientId && selectedAuthId) {
            setIsAuthorizationModalActive(true);
            GetClientById();
        }

    }, [selectedClientId, selectedAuthId]);

    useEffect(() => {
        GetPayorInfoTypes();
        GetAuthorizationStatuses();
        GetAllAuthsNotImported();
        GetCenterAuthorizations();
        GetDenialReasons();
        GetAuthFeedbackOptions();
        GetAuthActions();
        GetAllClientsList(true); // true to include inactive? Not sure if this is wanted, but we will find out
    }, []);


    useEffect(() => {
        var tempList = centerAuthorization.filter(x =>
            x.reportDueDate && new Date(x.reportDueDate) <= new Date()
        );

        setExpiredAuthorizations(tempList);

    }, [centerAuthorization]);

    useEffect(() => {
        setNoAuthorizationsImportedFiltered(noAuthsImportedMaster); 

    }, [noAuthsImportedMaster]);

    /*useEffect(() => {
        if (selectedClientChoice) {
            setSelectedClientId(Number(selectedClientChoice.value));   // call to get the client object by id
            setSelectedCenter(null);

            // need to filter the lists of auths here
            var tempExpiredList = centerAuthorization.filter(x =>
                x.clientId === Number(selectedClientChoice.value) &&
                x.reportDueDate && // exclude null or undefined
                new Date(x.reportDueDate) <= new Date()
            );
            var tempNoAuthImported = noAuthsImportedMaster.filter(x => x.clientId === Number(selectedClientChoice.value));

            setExpiredAuthorizations(tempExpiredList);
            setNoAuthorizationsImportedFiltered(tempNoAuthImported);
        }
    }, [selectedClientChoice]);

    // when the center dd is chosen, clear out client selection
    useEffect(() => {
        if (selectedCenter) {
            setSelectedClientId(null);   // call to get the client object by id
            setSelectedClientChoice(null);

            // need to filter the lists of auths here
            var tempExpiredList = centerAuthorization.filter(x =>
                x.centerId === selectedCenter.centerId &&
                x.reportDueDate && // exclude null or undefined
                new Date(x.reportDueDate) <= new Date()
            );
            var tempNoAuthImported = noAuthsImportedMaster.filter(x => x.centerName === selectedCenter.centerName);

            setExpiredAuthorizations(tempExpiredList);
            setNoAuthorizationsImportedFiltered(tempNoAuthImported);

            // set new objects for sorting?

        }
    }, [selectedCenter]);*/

    function GetAllClientsList(IncludeInactive: boolean) {

        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Clients/GetAllClientsList?includeInactive=" + IncludeInactive;
            //setLoading(true);
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setClients(result);
                        //setLoading(false);
                        console.log("raw all clients:", result);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetAllClientsList" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })

    }

    function GetAllAuthsNotImported() {

        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAllAuthsNotImported";
            setIsLoading(true);
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setNoAuthsImportedMaster(result);
                        setIsLoading(false);
                    },
                    (error) => {
                        setIsLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAllAuthsNotImported" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })

    }

    function GetClientById() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Clients/GetClientByID?clientId=" + selectedClientId;
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setSelectedClient(result);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetClientByID" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetCenterAuthorizations() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAllCenterAuthorizations";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setCenterAuthorization(result);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAllCenterAuthorizations" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetPayorInfoTypes() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetPayorInfoTypes";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setPayorInfoTypes(result);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetPayorInfoTypes" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    /* Get payor status  authorizationStatus*/

    function GetAuthorizationStatuses() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");

            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthorizationStatuses";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthorizationStatuses(result);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthorizationStatuses" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetDenialReasons() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthDenialReasonLookup";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthDenialReasons(result);
                    },
                    (error) => {
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthDenialReasonLookup" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetAuthFeedbackOptions() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthFeedbackLookup";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthFeedbackOptions(result);
                    },
                    (error) => {
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthFeedbackLookup" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetAuthActions() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");

            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthActionLookup";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthActions(result);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthActionLookup" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }


    // sorting functionality

    /*const [expiredSort, setExpiredSort] = useState({ column: "", direction: "asc" });
    const [noAuthSort, setNoAuthSort] = useState({ column: "", direction: "asc" });

    const sortedExpired = sortData(expiredAuthorizations, expiredSort.column, expiredSort.direction);
    const sortedNoAuth = sortData(noAuthorizationsImportedFiltered, noAuthSort.column, noAuthSort.direction);

    function sortData(data: any, column: any, direction: any) {
        if (!column) return data;

        return [...data].sort((a, b) => {
            let aVal = a[column];
            let bVal = b[column];

            // Handle nested data or transformations
            if (aVal instanceof Date || bVal instanceof Date) {
                aVal = new Date(aVal);
                bVal = new Date(bVal);
            }

            if (typeof aVal === "string") aVal = aVal.toLowerCase();
            if (typeof bVal === "string") bVal = bVal.toLowerCase();

            if (aVal < bVal) return direction === "asc" ? -1 : 1;
            if (aVal > bVal) return direction === "asc" ? 1 : -1;
            return 0;
        });
    }

    function handleSortClick(table: any, column: any) {
        if (table === "expired") {
            setExpiredSort(prev => ({
                column,
                direction: prev.column === column && prev.direction === "asc" ? "desc" : "asc"
            }));
        } else if (table === "noAuth") {
            setNoAuthSort(prev => ({
                column,
                direction: prev.column === column && prev.direction === "asc" ? "desc" : "asc"
            }));
        }
    }*/


    // State for sorting (per table)
    type SortDirection = 'asc' | 'desc';

    const [expiredSortConfig, setExpiredSortConfig] = useState<{
        key: keyof VwCenterAuthorization | null;
        direction: SortDirection;
    }>({ key: null, direction: 'asc' });

    const [noAuthSortConfig, setNoAuthSortConfig] = useState<{
        key: keyof VwCenterAuthorization | null;
        direction: SortDirection;
    }>({ key: null, direction: 'asc' });

    // Filter by Client
    useEffect(() => {
        if (selectedClientChoice) {
            const clientId = Number(selectedClientChoice.value);
            setSelectedClientId(clientId);
            setSelectedCenter(null);

            const tempExpiredList = centerAuthorization.filter(x =>
                x.clientId === clientId && isOnOrBeforeToday(x.reportDueDate)
            );

            const tempNoAuthImported = noAuthsImportedMaster.filter(x =>
                x.clientId === clientId
            );

            setExpiredAuthorizations(tempExpiredList);
            setNoAuthorizationsImportedFiltered(tempNoAuthImported);

            // optional: reset sort state here
            setExpiredSortConfig({ key: null, direction: "asc" });
            setNoAuthSortConfig({ key: null, direction: "asc" });
        }
    }, [selectedClientChoice, centerAuthorization, noAuthsImportedMaster]);

    // Filter by Center
    useEffect(() => {
        if (selectedCenter) {
            setSelectedClientId(null);
            setSelectedClientChoice(null);

            const tempExpiredList = centerAuthorization.filter(x =>
                x.centerId === selectedCenter.centerId && isOnOrBeforeToday(x.reportDueDate)
            );

            const tempNoAuthImported = noAuthsImportedMaster.filter(x =>
                x.centerName === selectedCenter.centerName
            );

            setExpiredAuthorizations(tempExpiredList);
            setNoAuthorizationsImportedFiltered(tempNoAuthImported);

            // optional: reset sort state here
            setExpiredSortConfig({ key: null, direction: "asc" });
            setNoAuthSortConfig({ key: null, direction: "asc" });
        }
    }, [selectedCenter, centerAuthorization, noAuthsImportedMaster]);

    const toDateOrNull = (v: unknown): Date | null => {
        if (v == null) return null;                    // null/undefined
        if (typeof v === "string" && v.trim() === "") return null; // empty string
        const d = new Date(v as any);
        return Number.isNaN(d.getTime()) ? null : d;   // invalid date → null
    };

    const isOnOrBeforeToday = (v: unknown): boolean => {
        const d = toDateOrNull(v);
        if (!d) return false;                          // exclude null/invalid
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        d.setHours(0, 0, 0, 0);
        return d.getTime() <= today.getTime();
    };

    // Generic sorting function
    const sortData = (
        data: any[],
        config: { key: string | null; direction: "asc" | "desc" }
    ) => {
        if (!config.key) return data; // no sorting if no key selected
        return [...data].sort((a, b) =>
            compareValues(a[config.key!], b[config.key!], config.direction)
        );
    };

    const compareValues = (a: any, b: any, dir: "asc" | "desc") => {
        const mult = dir === "asc" ? 1 : -1;
        const da = toDateOrNull(a);
        const db = toDateOrNull(b);
        if (da || db) {
            if (!da && !db) return 0;
            if (!da) return 1 * mult;  // nulls last
            if (!db) return -1 * mult;
            return (da.getTime() - db.getTime()) * mult;
        }
        if (a == null && b == null) return 0;
        if (a == null) return 1 * mult;
        if (b == null) return -1 * mult;
        if (typeof a === "string" && typeof b === "string") return a.localeCompare(b) * mult;
        return (a < b ? -1 : a > b ? 1 : 0) * mult;
    };

    // Click handler for sorting
    const handleSort = (table: any, key: any) => {
        if (table === "expired") {
            setExpiredSortConfig(prev => ({
                key,
                direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc"
            }));
        } else if (table === "noAuth") {
            setNoAuthSortConfig(prev => ({
                key,
                direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc"
            }));
        }
    };

    // Sorted data (memoized so it only changes when data/config changes)
    const sortedExpiredAuthorizations = useMemo(
        () => sortData(expiredAuthorizations, expiredSortConfig),
        [expiredAuthorizations, expiredSortConfig]
    );


    const sortedNoAuthorizationsImportedFiltered = useMemo(
        () => sortData(noAuthorizationsImportedFiltered, noAuthSortConfig),
        [noAuthorizationsImportedFiltered, noAuthSortConfig]
    );

    // Icons
    function getSortIcon(columnKey: string, sortConfig: { key: string | null; direction: 'asc' | 'desc' }) {
        if (sortConfig.key !== columnKey) {
            return faSort; // neutral icon if not sorted by this column
        }
        return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
    }



    return (

        <div className="grid grid-rows-auto ml-auto mr-auto">

            <div className="grid grid-cols-1 h-fit mt-0 mb-8">

                <div onClick={NavigateBack} className="my-2 flex items-center justify-center w-fit cursor-pointer col-span-2">
                    <div className="flex-1">
                        <FontAwesomeIcon className="w-8 h-8 mr-auto align-middle" icon={solid('arrow-left')} />
                    </div>
                    <span className="text-xl w-auto ml-3">Back</span>
                    <div className="flex-1"></div>
                </div>

                <div className="grid grid-flow-row grid-cols-1">

                    <div className="grid grid-cols-1 gap-4 xl:gap-[4.5rem] content-between xl:w-fit xl:m-auto">

                        <div className="grid grid-cols-1 h-fit w-800 p-5 mx-auto">

                            {/*<div className="w-full xl:w-[16rem] m-auto">
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <span className="ml-3 text-sm font-medium">My Authorizations</span>
                                    <input type="checkbox" onChange={event => setIsMyCentersChecked(event.target.checked)} checked={isMyCentersChecked} className="sr-only peer" />
                                    <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                    <span className="ml-3 text-sm font-medium">Center Authorizations</span>
                                </label>
                            </div>*/}

                            <div className="grid grid-cols-4 w-full m-auto gap-4">

                                <div className="w-full">
                                    <label className="font-bold" htmlFor="pods">
                                        Learner:
                                    </label>
                                    <Select className="outline-0" options={clients ? clients : undefined} onChange={setSelectedClientChoice} value={selectedClientChoice} />
                                </div>

                                <div className="w-full">
                                    <label className="font-bold" htmlFor="pods">
                                        Center:
                                    </label>
                                    <Select
                                        options={globalContext.lockdownCenters}
                                        onChange={setSelectedCenter}
                                        value={selectedCenter}
                                    />
                                </div>

                            </div>


                            <div className={"grid grid-cols-2 " + (isLoading ? "hidden" : "")}>
                                <div className="w-full ml-auto p-2 border-2 border-lacblue rounded-lg m-2">
                                    <div className="w-full flex items-center justify-between">

                                        <h2 className="text-2xl text-lacblue w-fit">Expired Authorizations</h2>

                                    </div>

                                    <div className="w-full max-h-96 overflow-y-auto">
                                        <table className="table-auto w-full">
                                            <thead className="w-full border border-lacblue-500">
                                                <tr className="bg-lacblue text-white hover:cursor-pointer">
                                                    <th onClick={() => handleSort("expired", "firstName")}>Learner <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('firstName', expiredSortConfig)} /></th>
                                                    <th onClick={() => handleSort("expired", "clientId")}>Learner ID <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('clientId', expiredSortConfig)} /></th>
                                                    <th onClick={() => handleSort("expired", "centerName")}>Center <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('centerName', expiredSortConfig)} /></th>
                                                    <th onClick={() => handleSort("expired", "startDate")}>Auth Start <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('startDate', expiredSortConfig)} /></th>
                                                    <th onClick={() => handleSort("expired", "endDate")}>Auth End <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('endDate', expiredSortConfig)} /></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Build out dependent on the view */}

                                                {sortedExpiredAuthorizations && sortedExpiredAuthorizations.length > 0 ? sortedExpiredAuthorizations.map((authorization : VwCenterAuthorization) =>
                                                    <tr className="border border-gray-500 text-center">
                                                        <td className="border border-gray-500"><span>{authorization.firstName + " " + authorization.lastName}</span></td>
                                                        <td className="border border-gray-500"><span>{authorization.clientId}</span></td>
                                                        <td className="border border-gray-500"><span>{globalContext && globalContext.centers.length > 0 && authorization.centerId ? globalContext.centers.find(x => x.centerId === authorization.centerId)?.centerName : "N/A"}</span></td>
                                                        <td className="border border-gray-500"><span>{new Date(authorization.startDate).toLocaleDateString()}</span></td>
                                                        <td className="border border-gray-500"><span>{new Date(authorization.endDate).toLocaleDateString()}</span></td>
                                                        <td onClick={e => HandleAuthorizationClick(authorization.authId, authorization.payorInfoType, authorization.clientId)} className="border border-gray-500"><FontAwesomeIcon className="float-right text-lacblue w-7 h-7 m-auto hover:cursor-pointer" icon={solid('circle-info')} ></FontAwesomeIcon></td>
                                                    </tr>
                                                ) : <tr><td colSpan={8} className="text-center text-rose">No Authorizations.</td></tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                </div>

                                <div className="w-full p-2 border-2 border-lacblue rounded-lg m-2">
                                    <div className="w-full flex items-center justify-between">

                                        <h2 className="text-2xl text-lacblue w-fit">No Authorizations Imported</h2>

                                    </div>

                                    <div className="max-h-96 overflow-y-auto">
                                        <table className="table-auto w-full">
                                            <thead className="w-full border border-lacblue-500">
                                                <tr className="bg-lacblue text-white hover:cursor-pointer">
                                                    <th onClick={() => handleSort("noAuth", "fullName")}>Learner <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('fullName', noAuthSortConfig)} /></th>
                                                    <th onClick={() => handleSort("noAuth", "clientId")}>Learner ID <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('clientId', noAuthSortConfig)} /></th>
                                                    <th onClick={() => handleSort("noAuth", "centerName")}>Center <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('centerName', noAuthSortConfig)} /></th>
                                                    <th onClick={() => handleSort("noAuth", "dob")}>DOB <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('dob', noAuthSortConfig)} /></th>
                                                    <th onClick={() => handleSort("noAuth", "startDate")}>Start Date <FontAwesomeIcon className="w-4 h-4 mr-auto align-middle" icon={getSortIcon('startDate', noAuthSortConfig)} /></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {sortedNoAuthorizationsImportedFiltered.length > 0 ? sortedNoAuthorizationsImportedFiltered.map((authorization: VwNoAuthorizations) =>
                                                    <tr className="border border-gray-500 text-center">
                                                        <td className="border border-gray-500"><span>{authorization.fullName}</span></td>
                                                        <td className="border border-gray-500"><span>{authorization.clientId}</span></td>
                                                        <td className="border border-gray-500"><span>{authorization.centerName}</span></td>
                                                        <td className="border border-gray-500"><span>{new Date(authorization.dob).toLocaleDateString()}</span></td>
                                                        <td className="border border-gray-500"><span>{new Date(authorization.startDate).toLocaleDateString()}</span></td>
                                                        <td onClick={NavigateToLearnerPage} className="border border-gray-500"><FontAwesomeIcon className="float-right text-lacblue w-7 h-7 m-auto hover:cursor-pointer" icon={solid('circle-info')} ></FontAwesomeIcon></td>
                                                    </tr>
                                                ) : <tr><td colSpan={8} className="text-center text-rose">No Authorizations.</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* loading here */}
                            <div className={"w-full h-auto flex " + (isLoading ? "" : "hidden")}>
                                <FontAwesomeIcon className="fill-current text-lacblue w-24 h-24 animate-spin m-auto" icon={solid('spinner')} />
                            </div>
                            

                        </div>

                    </div>

                    <AuthorizationModal Client={selectedClient} AuthId={selectedAuthId} AuthPayorType={selectedAuthPayorType} PayorInfoTypes={payorInfoTypes} AuthorizationStatuses={authorizationStatuses} AuthorizationDenialReasons={authDenialReasons} AuthorizationFeedbackOptions={authFeedbackOptions} AuthorizationActions={authActions} Active={isAuthorizationModalActive} setActive={setIsAuthorizationModalActive} OnModalClose={OnModalClose} IsInsurance={true}></AuthorizationModal>
                </div>

            </div>
        </div>
    );

}

export function InsuranceAuthorizations() {

    const authRequest = {
        ...loginRequest
    };

    return (
        <>

            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest} errorComponent={ErrorComponent} loadingComponent={Loading}>
                <ProtectedPage RequiredRoles={['Authorizations.InsuranceAccess']}>
                    <InsuranceAuthorizationsContent />
                </ProtectedPage>

            </MsalAuthenticationTemplate>

            <UnauthenticatedTemplate>

            </UnauthenticatedTemplate>

        </>
    );
}